// 获取store中的 token
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { api, apiStandard24, frontConf, hotelImgConfUrl } from './Api.env.config';
import hua from '@hweb/hua-js';
import { getCookieAndWindow, saveCookieAndWindow } from '@common/utils/utils';
import { getUrlQuery } from '@common/utils/token';
import { hzPortalVerConst, GATEWAY_PASS_TYPE } from '@common/utils/constants';
import uuid from '@common/utils/uuid';
import { track } from '@common/utils/ServiceTrack';
import { createPortalSignature, PORTAL_SIGNATURE_OPERATION } from '@common/utils/portalSignature';
import { getPortalSecurityError } from '@common/utils/portalSecurity';

export const ajax = axios.create();
axiosRetry(axios, { retries: 1 });
// axios 华住活动后台request拦截器 处理与华住活动后台相匹配的登录权限、数据格式等

let useCanary = false;
// 在header设置version等于canary方式命中preview服务

try {
  if (getUrlQuery('version') == 'canary' || window.location.hostname == 'pre-haoportal.huazhu.com') {
    useCanary = true;
  }
} catch (e) {
  
}


ajax.interceptors.request.use((config) => {
  let { url, data, headers, method, params = {}, uselog = true, hzPortalVer = hzPortalVerConst.V22 } = config;
  const { tk_pid, ...requestBody } = data;
  let reqBody = requestBody;
  const requestId = uuid();

  // 仅短信和会员接口使用 HMAC sign，覆盖传入的旧签名并移除已废弃的 securitySign。
  if (config.portalSignatureOperation) {
    try {
      delete reqBody.securitySign;
      reqBody = {
        ...reqBody,
        ...createPortalSignature({ ...reqBody, operation: config.portalSignatureOperation, hzPortalVer }),
      };
    } catch (error) {
      // 接入现有响应失败链路，避免同步异常导致 Saga 的 loading 无法释放。
      error.config = { ...config, requestId, apiPath: url, requestStartTime: Date.now(), uselog };
      error.portalSignatureError = true;
      return Promise.reject(error);
    }
  }
  // 处理url
  let baseURL = '';
  if (/^\//.test(url)) baseURL = api;

  if (hzPortalVer == hzPortalVerConst.V24) {
    baseURL = apiStandard24;
  }

  // 处理数据格式
  if (!headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';

    if (method !== 'post') {
      params = params ? { ...reqBody, ...params } : data;
    }
  }

  let roomNoAuthTimes = 0, smsAuthTimes = 0;


  let frontendSparams, sessionId = '', deviceId = '', pid = '';

  try {
    if (window.apmPlus && window.apmPlus('config')) {
      ({ deviceId, pid, sessionId } = window.apmPlus('config'));
    }
  } catch (e) {
    console.error(e)
  }

  const __gateway_uuid = getUrlQuery('uuid') || getCookieAndWindow('gateway_uuid') || '';

  if (__gateway_uuid) {
    sessionId = __gateway_uuid
  }

  headers['V-Id'] = sessionId;

  frontendSparams = `${pid},${deviceId},${requestId},${sessionId}`;

  headers['Frontend-Sparams'] = frontendSparams;


  if (useCanary) { //增加请求头命中金丝雀
    headers['version'] = 'disable-canary-cookie';
  }

  let _quertyHotelId = getUrlQuery('hotelId') || '';
  if (_quertyHotelId) {
    headers['X-Hotel-Id'] = _quertyHotelId;
  }

  let __trackParam = {
    portal_tag: 'api',
    portal_req_id: requestId,
    portal_type: url || '',
    portal_api_startTimming: Date.now()
  }

  let portal_api_param_auth_type, portal_api_param_page_type;
  
  if (url.indexOf('v2/api/wifi/pass') >-1 || url.indexOf('portalapi/api_auth') > -1) {

    portal_api_param_auth_type = reqBody.type;
    portal_api_param_page_type = reqBody.pageType;
    roomNoAuthTimes = reqBody.roomNoAuthTimes
    smsAuthTimes = reqBody.smsAuthTimes
    __trackParam = {
      ...__trackParam,
      portal_api_param_auth_type,
      portal_api_param_page_type,
      portal_roomNoAuthTimes: roomNoAuthTimes,
      portal_smsAuthTimes: smsAuthTimes
    }
  }

  if (uselog) {
    track.onEvent('service_portal_api_request', __trackParam);
  }

  return {
    ...config,
    frontendSparams,
    requestId,
    requestStartTime: Date.now(),
    portal_api_param_auth_type,
    portal_api_param_page_type,
    uselog,
    hzPortalVer,
    roomNoAuthTimes,
    smsAuthTimes,
    // withCredentials: true,
    data: reqBody,
    params,
    headers,
    baseURL,
    apiPath: url,
    timeout: 60000,
  };
});

// axios 华住活动后台response拦截器 处理响应数据及底层容错
ajax.interceptors.response.use(
  (res) => {
    const {
      status,
      data,
      config: { requestStartTime, apiPath, requestId, uselog, hzPortalVer, preserveSecurityError, portal_api_param_auth_type, portal_api_param_page_type,
        roomNoAuthTimes,
        smsAuthTimes,
       },
    } = res;

    const { message, businessCode, code, success } = data;

    let tkcode = 1,
      bizCode = '';

    if (hzPortalVer == hzPortalVerConst.V24) {
      bizCode = code || '';
    } else {
      bizCode = businessCode || '';
    }

    if (hzPortalVer == hzPortalVerConst.V24) {
      tkcode = success ? 1 : 0;
    } else {
      tkcode = businessCode == '1000' ? 1 : 0;
    }

    if (uselog) {
      let __now = Date.now();
      let __headerResTime = '';
      if (res.headers) {
        __headerResTime = new Date(res.headers.date).getTime();
      }

      let __trackParam = {
        portal_tag: 'api',
        portal_req_id: requestId,
        portal_type: apiPath || '',
        portal_apitimming: __now - requestStartTime,
        portal_api_startTimming: requestStartTime || '',
        portal_api_endTimming: __now || '',
        portal_api_headerResTime: __headerResTime || '',
        portal_status: tkcode,
        // 受影响接口只记录结果类别，避免服务端错误文案回显敏感参数。
        portal_message: preserveSecurityError ? (tkcode ? '请求成功' : '业务失败') : message,
        portal_businessCode: `${bizCode}`,
      }

      if (apiPath.indexOf('v2/api/wifi/pass') >-1 || apiPath.indexOf('portalapi/api_auth') > -1) {
        __trackParam['portal_api_param_auth_type'] = portal_api_param_auth_type;
        __trackParam['portal_api_param_page_type'] = portal_api_param_page_type;
        __trackParam['portal_roomNoAuthTimes'] = roomNoAuthTimes;
        __trackParam['portal_smsAuthTimes'] = smsAuthTimes;
      }

      track.onEvent('service_portal_api', __trackParam);
    }
    if (status === 200) return data;
  },
  (error) => {
    // 只调整签名接口和网关认证的失败契约，其他历史接口保持原行为。
    const preserveSecurityError = error.config && error.config.preserveSecurityError;
    const securityError = preserveSecurityError ? getPortalSecurityError(error) : null;
    try {
      const {
        config: { requestStartTime, apiPath, requestId, uselog, portal_api_param_auth_type, portal_api_param_page_type,     roomNoAuthTimes,
          smsAuthTimes, },
        message,
      } = error;
      if (!preserveSecurityError) {
        console.log('底层出错:', error);
        console.dir(error);
      }
      if (uselog) {

      let __trackParam = {
        portal_tag: 'api',
        portal_req_id: requestId,
        portal_type: apiPath || '',
        portal_apitimming: Date.now() - requestStartTime,
        portal_status: 0,
        // 安全请求不输出错误对象或可能含手机号、签名的完整 URL。
        portal_message: preserveSecurityError ? '请求失败' : message,
      }

        if (apiPath.indexOf('v2/api/wifi/pass') >-1 || apiPath.indexOf('portalapi/api_auth') > -1) {
          __trackParam['portal_api_param_auth_type'] = portal_api_param_auth_type
          __trackParam['portal_api_param_page_type'] = portal_api_param_page_type
          __trackParam['portal_roomNoAuthTimes'] = roomNoAuthTimes;
          __trackParam['portal_smsAuthTimes'] = smsAuthTimes;
  
        }
        if (preserveSecurityError) {
          __trackParam.portal_http_status = error.response ? error.response.status : '';
          __trackParam.portal_businessCode = securityError ? `${securityError.errorCode}` : '';
          __trackParam.portal_failure_type = error.portalSignatureError ? 'signature' : 'request';
        }
        track.onEvent('service_portal_api', __trackParam);
      }
    } catch (e) {}

    return securityError || {
      code: 700,
    };
  }
);

/* ***** 接口列表 ***** */

//MARK: 获取全触点活动列表
export const getAllContact = (data) => {
  return ajax({
    url: `/api/fulltouch/getcfg`,
    method: 'post',
    data,
  });
};

//MARK: 曝光活动
export const exposureActivity = (data) => {
  return ajax({
    url: '/api/fulltouch/addexposuretimes',
    method: 'post',
    data,
  });
};

//MARK: 微信一键认证的 schema生成
export const generateWxUrl = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => new Promise((rsv, rej) => {

  let url = '/v2/api/wifi/wxmpurl';

  if (hzPortalVer == hzPortalVerConst.V24) {
    url = '/portalapi/api_authpage_wxmp_schema';
  }

  ajax({
    url,
    method: 'post',
    data,
    hzPortalVer
  })
  .then(res => {

    let _rsvData;

    if (hzPortalVer == hzPortalVerConst.V24 && res.success && res.data) {
      _rsvData = {
        code: res.code,
        content: res.data
      }
    } else {
      _rsvData = res;
    }

    rsv(_rsvData)

  })
  .catch(e => {
    rej(e)
  })
})


//MARK: hotelInfo
export const getHotelInfo = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) =>
  new Promise((rsv, rej) => {
    // hzPortalVer = 'V22'
    let _url = hzPortalVer == hzPortalVerConst.V24 ? '/portalapi/api_index_page_info' : '/v2/api/wifi/init';

    ajax
      .post(_url, data, { hzPortalVer })
      .then((res) => {
        let _rsvData;
        let _bizCode;
        let isRoam, hotelStyle, mac, hotelId, memberId, area, traceNo, isRcHotel, netsupplier, isWxmpHotel, enableTvAndRoomGoodsService, hotelName, hotelNameEn;
        let brandNo = null;
        if (hzPortalVer == hzPortalVerConst.V24 && res.data) {
          ({ memberId, mac, netsupplier, isWxmpHotel } = res.data);
          const _hotelData = (res.data.hotelInfoList && res.data.hotelInfoList.length > 0) ? res.data.hotelInfoList[0] : null;
          if (_hotelData) {
            ({ hotelId, hotelStyle, hotelName, hotelNameEn, brandNo } = _hotelData);
          }
          _rsvData = {
            code: res.code,
            content: Object.assign(
              {},
              {
                memberId: memberId,
                mac: mac,
                hotelId: hotelId,
                hotelName: hotelName,
                hotelNameEn: hotelNameEn,
                hotelStyle: hotelStyle,
                brandNo: brandNo,
                city: res.data.city,
                area: res.data.area,
                netsupplier: netsupplier,
                passUrl: res.data.passUrl,
                passType: GATEWAY_PASS_TYPE.URL_JUMP,
                tempPassUrl: res.data.tempPassUrl,
                isWxmpHotel: res.data.isWxmpHotel || true,
                pcQrcode: res.data.pcQrcode,
                isRoam: res.data.passUrl,
              },
              res.data
            ),
          };
        } else if (res.content) {
          _rsvData = {
            content: res.content,
            code: res.businessCode,
          };
        }

        if (hzPortalVer == hzPortalVerConst.V24) {
          _bizCode = res.code
        } else {
          _bizCode = res.businessCode
        }


        if (_rsvData) {
          ({ isRoam, hotelStyle, mac, hotelId, memberId, area, traceNo, isRcHotel, netsupplier, isWxmpHotel, enableTvAndRoomGoodsService } = _rsvData.content);

          const _roam = isRoam ? 1 : 0;

    track.globalConfig({
      service_common_protal_hotel_id: hotelId,
      hotelId: hotelId,
      mac: mac,
      service_common_protal_mac: mac,
      service_common_protal_isWxmpHotel: isWxmpHotel,
      service_common_protal_roam: `${isRoam}`,
      service_common_protal_netsupplier: netsupplier,

    })

          track.config({
            hotel_id: hotelId,
            portal_mac: mac,
            portal_isWxmpHotel: isWxmpHotel,
            portal_roam: `${isRoam}`,
            portal_netsupplier: netsupplier,
          });

          // 用户埋点使用初始化接口的设备 MAC，不再依赖会员编号是否返回。
          track.setUserUniqueID(mac);

          if (window.apmPlus) {
            window.apmPlus('context.set', 'hotelId', hotelId || '');

            if (memberId) {
              window.apmPlus('config', {
                userId: memberId,
              });
            }

            window.apmPlus('start');
          }

          saveCookieAndWindow('traceNo', traceNo || '');
          saveCookieAndWindow('roam', _roam, 1);
          saveCookieAndWindow('hotelStyle', hotelStyle);
          saveCookieAndWindow('brandNo', brandNo);
          saveCookieAndWindow('mac', mac, 1);
          saveCookieAndWindow('hotelId', hotelId, 1);
          saveCookieAndWindow('memberId', memberId || '', 1);
          saveCookieAndWindow('area', area);
          saveCookieAndWindow('isRcHotel', isRcHotel);
          saveCookieAndWindow('netsupplier', netsupplier);
          saveCookieAndWindow('serviceEnable', enableTvAndRoomGoodsService);
        } else { 
          //MARK: 兜底异常逻辑
          _rsvData = {
            code: _bizCode,
            content: {},
          }
        }

        console.log('@@@ getHotelInfo res', res, _rsvData)

        rsv(_rsvData);
      })
      .catch((e) => {
        rej(e);
      });
  });

export const autoRetryHotelInfo = (data, { retryTimes = 1, hzPortalVer = getUrlQuery('hzPortalVer') } = {}) =>
  new Promise(async (res, rej) => {
    let _times = 0,
      _infoData,
      _error;
    while (_times <= retryTimes && !_infoData) {
      _times++;
      try {
        _infoData = await getHotelInfo(data, { hzPortalVer });
      } catch (e) {
        _error = e;
      }
    }

    if (_infoData) {
      res(_infoData);
    } else {
      rej(_error);
    }
  });

//MARK:  查看是否是华住会员
export const checkHzMember = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => {
  let _url = '/v2/api/wifi/ismember';
  let method = 'post';
  if (hzPortalVer == hzPortalVerConst.V24) {
    _url = '/portalapi/api_ismember';
    method = 'get';
  }
  return ajax({
    url: _url,
    method,
    data,
    hzPortalVer,
    // 在请求时生成 HMAC sign，不调整会员接口当前的返回内容。
    portalSignatureOperation: PORTAL_SIGNATURE_OPERATION.MEMBER,
    preserveSecurityError: true,
  });
};
//MARK:  认证 放行
export const verifyPass = (data, {hzPortalVer = getUrlQuery('hzPortalVer') } = {}) =>
  new Promise((rsv, rej) => {
    let _url = hzPortalVer == hzPortalVerConst.V24 ? '/portalapi/api_auth' : '/v2/api/wifi/pass';
    // 放行接口不再传旧签名，也不复用短信/会员接口的一次性 HMAC。
    const authData = { ...data };
    delete authData.sign;
    delete authData.securitySign;
    ajax({
      url: _url,
      method: 'post',
      data: authData,
      hzPortalVer,
      // 网关拒绝请求时保留错误信息，但不向认证接口添加安全签名字段。
      preserveSecurityError: true,
    })
      .then((res) => {
        let _rsvData;
        if (hzPortalVer == hzPortalVerConst.V24 && res.success && res.data) {
          _rsvData = {
            code: res.code,
            success: res.success,
            content: {
              ...res.data,
              passType: GATEWAY_PASS_TYPE.URL_JUMP,
            },
          };
        } else {
          _rsvData = res;
        }
        rsv(_rsvData);
      })
      .catch((e) => {
        rej(e);
      });
  });

export const huaRequestverifyPass = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => {
  // 原生扫码放行同样去掉历史签名参数，不影响 SDK 的登录态处理。
  const authData = { ...data };
  delete authData.sign;
  delete authData.securitySign;
  let url = `${api}/v2/api/wifi/pass`;

  if (hzPortalVer == hzPortalVerConst.V24) {
    url = `${apiStandard24}/portalapi/must/api_auth`;
  }


  let headers = {}


  try {
    if (getUrlQuery('version') == 'canary' || window.location.hostname == 'pre-haoportal.huazhu.com') {
      headers['version'] = 'disable-canary-cookie';
    }
  } catch (e) {
    
  }

  let _quertyHotelId = getUrlQuery('hotelId') || '';

  if (_quertyHotelId) {
    headers['X-Hotel-Id'] = _quertyHotelId;
  }


  return hua.request({
    url,
    data: authData,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
  }).catch((error) => {
    // SDK 若保留了 HTTP 响应，则统一安全错误；其他异常继续交由原调用方处理。
    const securityError = getPortalSecurityError(error);
    if (securityError) return securityError;
    throw error;
  });
};

//MARK:  获取短信验证码
export const sendMessage = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => {
  let _url = '/v2/api/wifi/sendsms';

  if (hzPortalVer == hzPortalVerConst.V24) {
    _url = '/portalapi/api_sendsms';
  }
  return ajax({
    url: _url,
    method: 'post',
    data,
    hzPortalVer,
    // 首发、重发均在请求拦截器重新生成 HMAC sign，不复用页面或缓存中的旧签名。
    portalSignatureOperation: PORTAL_SIGNATURE_OPERATION.SMS,
    preserveSecurityError: true,
  });
};

//MARK:  保存上网记录
export const saveRecord = (data) =>
  ajax({
    url: `/v2/api/wifi/netsuccess`,
    method: 'post',
    data,
  });

//MARK:  国家码
export const countrycode = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => {
  let _url = hzPortalVer == hzPortalVerConst.V24 ? '/portalapi/api_countrycode' : '/v2/api/wifi/countrycode';

  return new Promise((rsv, rej) => {
    ajax({
      url: _url,
      method: 'get',
      data,
      hzPortalVer,
    })
      .then((res) => {
        let _rsvData;
        if (res.data) {
          _rsvData = res.data;
        } else if (res.content) {
          _rsvData = res.content;
        }

        rsv(_rsvData);
      })
      .catch((e) => {
        rej(e);
      });
  });
};

//MARK: 轮询扫码状态
export const checkAuthStatus = (data, { uselog = false, hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => {
  let _url = '/v2/api/wifi/pcstaus',
    method = 'post';

  if (hzPortalVer == hzPortalVerConst.V24) {
    _url = '/portalapi/api_pcstatus';
    method = 'get';
  }

  return new Promise((rsv, rej) => {
    ajax({
      url: _url,
      method,
      data,
      uselog,
      hzPortalVer,
    })
      .then((res) => {
        let _rsvData;
        if (hzPortalVer == hzPortalVerConst.V24 && res.success && res.data) {
          _rsvData = {
            content: {
              ...res.data,
              passType: GATEWAY_PASS_TYPE.URL_JUMP,
            }
          };
        } else if (res.content) {
          _rsvData = res;
        }
        rsv(_rsvData);
      })
      .catch((e) => {
        rej(e);
      });
  });
};

//MARK: 手机端轮询获取联网状态
export const mobileCheckAuthStatus = (data, { uselog = false } = {}) => {
  let _url = '/portalapi/api_net_status',
    method = 'get';
  return ajax({
    url: _url,
    method,
    data,
    uselog,
    hzPortalVer: hzPortalVerConst.V24,
  });
};

//MARK: 上报扫码状态
export const upQrStatus = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) =>
  new Promise((rsv, rej) => {
    let _url = '/v2/api/wifi/uppcstatus',
      method = 'post';

    if (hzPortalVer == hzPortalVerConst.V24) {
      _url = '/portalapi/api_uppcstatus';
      method = 'get';
    }

    ajax({
      url: _url,
      method,
      data,
      hzPortalVer,
    })
      .then((res) => {
        let _rsvData;
        if (hzPortalVer == hzPortalVerConst.V24 && res.success && res.data) {
          _rsvData = {
            code: res.code,
            content: res.data,
          };
        } else {
          _rsvData = res;
        }
        rsv(_rsvData);
      })
      .catch((e) => {
        rej(e);
      });
  });

//MARK: 获取酒店服务列表
export const hotelServiceList = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => new Promise((rsv, rej) => {
  let url = '/v2/api/wifi/service/show';

  if (hzPortalVer == hzPortalVerConst.V24) {
    url = '/portalapi/api_serviceshow';
  }

  ajax({
    url,
    method: 'post',
    data,
    hzPortalVer,
  })
  .then(res => {
    let _rsvData;
    if (hzPortalVer == hzPortalVerConst.V24 && res.success && res.data) {
      _rsvData = {
        code: res.code,
        content: res.data,
      };
    } else {
      _rsvData = res;
    }
    rsv(_rsvData);
  })
  .catch(e => {
    rej(e)
  })
});

//MARK: 生成打开微信的schema 打开服务频道
export const creatWxschema = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) => new Promise((rsv, rej) => {
  let url = '/v2/api/wifi/service/schema';

  if (hzPortalVer == hzPortalVerConst.V24) {
    url = '/portalapi/api_service_schema';
  }
  
  ajax({
    url,
    method: 'post',
    data,
    hzPortalVer
  }).then(res => {
    let _rsvData;
    if (hzPortalVer == hzPortalVerConst.V24 && res.success && res.data) {
      _rsvData = {
        code: res.code,
        content: res.data,
      };
    } else {
      _rsvData = res;
    }
    rsv(_rsvData);

  }).catch(e => {
    rej(e)
  })
})
//MARK: 上报设备
export const blacklist = (data) =>
  new Promise((res, rej) => {
    ajax
      .post('/api/wifi/blacklist', data)
      .then((data) => {
        res(data);
      })
      .catch((e) => {
        rej(e);
      });
  });

//MARK: 轮询外网资源
export const fetchInternetSource = (url) =>
  new Promise((res, rej) => {
    axios
      .get(url, {
        timeout: 1000,
      })
      .then((response) => {
        console.log('fetchInternetSource success');
        res(1);
      })
      .catch((error) => {
        console.log('fetchInternetSource error');
        rej(0);
      });
  });

export const getPortalConfig = () =>
  new Promise((res, rej) => {
    axios
      .get(frontConf, {
        timeout: 1000,
      })
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        res(0);
      });
  });


export const getEnCountryCodeConf = () =>
  new Promise((res, rej) => {
    axios
      .get('https://res-pub.huazhu.com/szh-pub/en/telAreaEn.json', {
        timeout: 10000,
      })
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        res(0);
      });
  });
export const getHotelImgConf = () =>
  new Promise((res, rej) => {
    axios
      .get(hotelImgConfUrl, {
        timeout: 30000,
      })
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        rej(error);
      });
  });

export const __SAMPLE = (data, { hzPortalVer = getUrlQuery('hzPortalVer') } = {}) =>
  new Promise((rsv, rej) => {
    let url = '/v2/api/wifi/xx';

    if (hzPortalVer == hzPortalVerConst.V24) {
      url = '/v2/api/wifi/xx';
    }

    ajax({
      url,
      method: 'post',
      data,
      hzPortalVer,
    })
      .then((res) => {
        let _rsvData;
        if (res.data) {
          _rsvData = {
            code: res.code,
            content: res.data,
          };
        } else {
          _rsvData = res;
        }
        rsv(_rsvData);
      })
      .catch((e) => {
        rej(e);
      });
  });
